import React from "react";
import styled from "styled-components";

import Container from "./Container";
import { Icon } from "./Icon";
import { FRENTES, DIAGNOSTICO, waLink } from "../data/diagnostico";

import LOGO from "../assets/media/logo_nav.png";

const FooterShell = styled.footer`
    width: 100%;
    margin-top: 96px;
    background: var(--ink-strong);
    color: rgba(255, 255, 255, 0.74);

    @media only screen and (max-width: 640px) {
        margin-top: 64px;
    }
`;

const FooterTop = styled.div`
    padding: 52px 0 26px;
    display: flex;
    justify-content: center;
`;

const FooterGrid = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: minmax(0, 1.15fr) minmax(180px, 0.6fr) minmax(180px, 0.6fr) minmax(220px, 0.85fr);
    gap: 32px;

    @media only screen and (max-width: 920px) {
        grid-template-columns: 1fr 1fr;
    }

    @media only screen and (max-width: 560px) {
        grid-template-columns: 1fr;
        gap: 28px;
    }
`;

const BrandColumn = styled.div`
    display: flex;
    flex-direction: column;
    gap: 14px;
    max-width: 340px;
`;

const LogoIcon = styled.img`
    width: 104px;
    height: auto;
    filter: brightness(0) invert(1);
`;

const BrandText = styled.p`
    margin: 0;
    font-size: 14.5px;
    font-weight: 500;
    line-height: 1.65;
    color: rgba(255, 255, 255, 0.7);
`;

const BrandMeta = styled.p`
    margin: 0;
    font-size: 13.5px;
    font-weight: 600;
    line-height: 1.6;
    color: rgba(255, 255, 255, 0.56);
`;

const FooterCol = styled.nav`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

const FooterLabel = styled.span`
    font-size: 12px;
    font-weight: 800;
    letter-spacing: 0.16em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.52);
`;

const FooterLink = styled.a`
    font-size: 14.5px;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.82);
    display: flex;
    align-items: center;
    gap: 4px;
    overflow-wrap: anywhere;
    transition: color 0.2s ease;

    &:hover {
        color: var(--brand-3);
    }
`;

const FooterBottom = styled.div`
    border-top: 1px solid rgba(255, 255, 255, 0.12);
`;

const FooterBottomRow = styled.div`
    padding: 18px 0 30px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 14px;
    font-size: 13.5px;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.56);
`;

function Footer() {
    const waGeral = waLink("Olá! Vim pelo site da Mango e quero conversar sobre o meu caso.");

    return (
        <FooterShell>
            <FooterTop>
                <Container css="width: min(1180px, calc(100vw - 32px));">
                    <FooterGrid>
                        <BrandColumn>
                            <a href="/" aria-label="Mango Software House — início">
                                <LogoIcon src={LOGO} alt="Mango Software House" />
                            </a>
                            <BrandText>
                                Sistemas, automações e sites sob medida para pequenas e médias empresas em todo o Brasil e em Portugal.
                            </BrandText>
                            <BrandMeta>Mango Software House<br />CNPJ 33.545.792/0001-39</BrandMeta>
                        </BrandColumn>

                        <FooterCol aria-label="Serviços">
                            <FooterLabel>Serviços</FooterLabel>
                            {FRENTES.map((frente) => (
                                <FooterLink key={frente.title} href={frente.route}>{frente.title}</FooterLink>
                            ))}
                        </FooterCol>

                        <FooterCol aria-label="Diagnóstico">
                            <FooterLabel>Diagnóstico</FooterLabel>
                            {DIAGNOSTICO.filter((item) => item.id !== "qa").map((item) => (
                                <FooterLink key={item.id} href={item.route}>{item.label}</FooterLink>
                            ))}
                            <FooterLink href="/cases">Cases</FooterLink>
                            <FooterLink href="/blog">Blog</FooterLink>
                        </FooterCol>

                        <FooterCol aria-label="Contato">
                            <FooterLabel>Contato</FooterLabel>
                            <FooterLink href="tel:+554191150056">+55 41 9115-0056</FooterLink>
                            <FooterLink href="mailto:contato@mangosoftwarehouse.com">contato@mangosoftwarehouse.com</FooterLink>
                            <FooterLink href={waGeral} target="_blank" rel="noreferrer">
                                <Icon name="chat" size="16px" />
                                Falar no WhatsApp
                            </FooterLink>
                        </FooterCol>
                    </FooterGrid>
                </Container>
            </FooterTop>

            <FooterBottom>
                <Container css="width: min(1180px, calc(100vw - 32px)); display: flex; justify-content: center;">
                    <FooterBottomRow>
                        <span>© 2026 Mango Software House</span>
                        <FooterLink href="/privacidade">Política de privacidade</FooterLink>
                    </FooterBottomRow>
                </Container>
            </FooterBottom>
        </FooterShell>
    );
}

export { Footer };
export default Footer;
